import { cn } from 'lib/helpers/utility';

import Icon from '../../Icon/Icon';

const Header = ({
  title,
  customTitle,
  headButton,
  headerClassName,
  headerCloseIcon = true,
  customHeader,
  prevButton,
  handleClose,
  headerCloseIconClassName
}) => {
  if (title && customTitle) {
    throw new Error('Modal header: Provide either "title" or "customTitle", not both.');
  }

  return (
    <div
      className={cn(
        'Modal__head',
        !customHeader && 'h-[48px]',
        customHeader && 'h-auto sm:h-auto',
        headerClassName
      )}
      data-dd-privacy="allow">
      {customHeader ? (
        customHeader
      ) : (
        <>
          <div className="Modal__head__left">
            {prevButton}
            <h6
              className={cn(
                'overflow-hidden text-ellipsis whitespace-nowrap text-sm font-600 leading-[17px] text-neutral-800',
                !customTitle && 'lowercase first-letter:uppercase'
              )}>
              {customTitle || title}
            </h6>
            <div className="grow">{headButton}</div>
          </div>
        </>
      )}
      {headerCloseIcon && (
        <div
          className={cn(
            'flex size-[26px] min-w-[26px] cursor-pointer items-center justify-center rounded-[4px] hover:bg-neutral-75',
            headerCloseIconClassName,
            headerCloseIconClassName && headerCloseIconClassName.includes('hidden') && 'hidden'
          )}
          onClick={handleClose}>
          <Icon data-qa="close-square-mono" icon="close-linear" className="cursor-pointer" />
        </div>
      )}
    </div>
  );
};

export default Header;
